import { render, staticRenderFns } from "./SearchTabContacts.vue?vue&type=template&id=3d557765&"
import script from "./SearchTabContacts.vue?vue&type=script&lang=js&"
export * from "./SearchTabContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports